import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router'

import { ManageBrandTab } from './ManageBrand'
import { ManageBrandDialogValidationMode } from './manageBrandsDialogContext'

interface UseManageBrandsDialogOptions {
  onClose?: () => void
}

const callbackRegistry: Record<
  string,
  {
    onClose?: () => void
  }
> = {}

const useManageBrandDialog = (options: UseManageBrandsDialogOptions) => {
  const [id] = useState(() => Math.random().toString(36))
  const history = useHistory()
  const location = useLocation()

  callbackRegistry[id] = {
    onClose: options.onClose,
  }

  useEffect(() => {
    return () => {
      delete callbackRegistry[id]
    }
  }, [id])

  return {
    showManageBrandDialog: (options: {
      retailerId: string
      initialTab?: ManageBrandTab
      subtitle?: string
      validationMode?: ManageBrandDialogValidationMode
      shouldHighlightMissing?: boolean
    }) => {
      const params = new URLSearchParams(location.search)

      params.append('manageBrandRetailerId', options.retailerId)

      if (options.initialTab) {
        params.append('manageBrandInitialTab', options.initialTab)
      }

      if (options.subtitle) {
        params.append('manageBrandSubtitle', options.subtitle)
      }

      if (options.validationMode) {
        params.append('manageBrandValidationMode', options.validationMode)
      }

      if (options.shouldHighlightMissing) {
        params.append(
          'manageBrandShouldHighlightMissing',
          String(options.shouldHighlightMissing),
        )
      }

      history.push({ search: params.toString() })
    },
  }
}

export const runCloseCallbacks = () => {
  for (const id in callbackRegistry) {
    callbackRegistry[id]?.onClose?.()
  }
}

export default useManageBrandDialog
